import React from 'react'
import PublicLayout from '../../components/universal/public-layout'
import PublicNavigation from '../../components/universal/public-navigation'
import BlogContent from '../../components/public/blog'
import PublicFooter from '../../components/universal/public-footer'

const Blog = ({Content}) => {
    return(
        <>
            <PublicLayout Navigation={() => <PublicNavigation white={true}/>} Content={() => <Content/>} Footer={() => <PublicFooter/>}/>
        </>
    )
}

export default Blog